import { useEffect, useMemo, useState } from 'react';
import { useGetMenuQuery } from '../../api/menuApi';
import { MenuItemDto } from '../../api-types';
import { groupBy } from 'lodash';
import {
    MenuItemGroup,
    MenuItemType
} from '../../api-types/models/MenuItemDto';

import './index.css';
import { useTranslation } from 'react-i18next';
import MenuItem from '../../components/menuItem';
import { formatDate } from '../../utils/date';
import { useAppSelector } from '../../app/hooks';
import { selectConfig } from '../../app/configSlice';

export function BarPage() {
    const { t } = useTranslation();
    const config = useAppSelector(selectConfig);

    const dateIso = formatDate(new Date());
    const pollingInterval =
        +(process.env.REACT_APP_MENU_FETCH_INTERVAL_IN_MINUTES ?? 5) *
        60 *
        1000;

    const { data: menuItems } = useGetMenuQuery(dateIso, {
        skip: !config,
        pollingInterval
    });

    const menu = useMemo(() => {
        if (!menuItems) {
            return {} as Record<string, MenuItemDto[]>;
        }

        return groupBy(
            menuItems.filter(
                (element) =>
                    element.costCenter === MenuItemType.BAR &&
                    element.group !== MenuItemGroup.USUAL_ITEMS
            ),
            'group'
        );
    }, [menuItems]);

    const [currentIndex, setCurrentIndex] = useState(0);

    useEffect(() => {
        const intervalId = setInterval(
            () => {
                setCurrentIndex(
                    (prevIndex) => (prevIndex + 1) % Object.keys(menu).length
                );
            },
            +(process.env.REACT_APP_BAR_OFFER_CHANGE_TIME_IN_SECONDS ?? 10) *
                1000
        );

        return () => {
            clearInterval(intervalId);
        };
    }, [menu]);

    const currentGroup = Object.keys(menu)[currentIndex];

    return (
        <div className='bar-offer'>
            <h2>{t(currentGroup?.toLowerCase())}</h2>
            {menu[currentGroup]?.map((item) => (
                <div className='bar-item' key={item.uuid}>
                    <MenuItem menuItem={item} />
                </div>
            ))}
        </div>
    );
}
